export default __webpack_public_path__ + "static/moores-law-b92a3e53ec163ffbd3774b1badfbd22e.gif";